// extracted by mini-css-extract-plugin
export default {"container":"style_container__HRYS9","card":"style_card__eoil9","row":"style_row__9J+ws","btnsRow":"style_btnsRow__ZwIMY"};